import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle} from "react";
import styled from "styled-components";

import {getNumber} from "utils/format";
import {getEventInfo} from "utils/event";
import Toast from "components/ui/Toast";

export const Slider = forwardRef(({isFix, isLoop, ...props}, ref) => {
	const self = useRef();
	const [index, setIndex] = useState(props.index);
	const [eventInfo] = useState({
		index : (props.index) ? props.index : 0, positionX : 0, direction : 0, container : document.getElementById("content")
	});

	useEffect(() => {
		window.addEventListener("resize", eventHandler.update);
		if(self.current) {
			if(isLoop) eventInfo.index = 1;
			eventHandler.update(self.current);
		}
		return () => {
			window.removeEventListener("resize", eventHandler.update);
		}
	}, []);

	useImperativeHandle(ref, () => ({
		prev : () => {
			eventHandler.setPosition(eventHandler.getPosition(1));
		},
		next : () => {
			eventHandler.setPosition(eventHandler.getPosition(-1));
		}
	}));

	const eventHandler = {
		update : (container) => {
			if(self.current)
				container = self.current || container;

			const div = container.querySelector("div");
			const nodeList = div.querySelectorAll(":scope > ul > li");

			const width = div.offsetWidth;
			eventInfo.width = width;
			eventInfo.node = div;
			eventInfo.nodeList = nodeList;
			eventInfo.max = (nodeList.length) ? nodeList.length - 1 : 0;
			eventInfo.positionX = (eventInfo.index) ? width * eventInfo.index * -1 : 0;
			eventInfo.maxPositionX = width * eventInfo.max * -1;

			eventInfo.node.classList.add("focus");
			eventHandler.setPosition(eventInfo.positionX);
			setTimeout(() => {
				eventInfo.node.classList.remove("focus");
			}, 100);
		},
		down : (event) => {
			event.stopPropagation();
			/*
			if(eventInfo.container)
				eventInfo.container.classList.add("hidden");
			*/

			if(!eventInfo.node) return;
			if(isLoop && eventInfo.isLock) return;
			event = getEventInfo(event);
			if(!event) return;

			eventInfo.node.classList.add("focus");

			eventInfo.x = event.x;
			eventInfo.y = event.y;
			eventInfo.id = event.id;
			eventInfo.direction = undefined;
			eventInfo.timestamp = Date.now();
			eventInfo.isDrag = false;

			if(event.type == "mousedown") {
				document.onmousemove = eventHandler.move;
				document.onmouseup = eventHandler.up;
			}
		},
		move : (event) => {
			event.stopPropagation();
			if(eventInfo.direction == "y") return;
			event = getEventInfo(event, eventInfo.id);

			if(!eventInfo.direction) {
				const x = Math.abs(eventInfo.x - event.x);
				const y = Math.abs(eventInfo.y - event.y);
				if(x == 0 && y < 5) return;
				eventInfo.direction = (y > x) ? "y" : "x";
			} else {
				let v = eventInfo.positionX + (event.x - eventInfo.x);
				if(isLoop) {
					const max = eventInfo.maxPositionX || 0;
					if(v > 0) v = 0;
					else if(v < max) v = max;
				}
				eventInfo.node.style.transform = `translateX(${v}px)`;
				if(props.onProgress) {
					const percent = (v * 100 / (eventInfo.maxPositionX - eventInfo.width)).toFixed(2);
					props.onProgress(percent);
				}
			}
		},
		up : (event) => {
			event.stopPropagation();
			/*
			if(eventInfo.container)
				eventInfo.container.classList.remove("hidden");
			 */

			eventInfo.node.classList.remove("focus");
			if(event.type == "mouseup") {
				document.onmousemove = document.onmouseup = null;
			}
			event = getEventInfo(event, eventInfo.id);
			const width = eventInfo.width;
			const v = event.x - eventInfo.x;
			if(Math.abs(v) > 5) {
				eventInfo.isDrag = true;
			}

			let positionX = eventInfo.positionX + v;
			const halfWidth = width * 0.5;
			if(width * 0.1 < Math.abs(v) && Math.abs(v) < halfWidth) {
				if(v < 0) positionX -= halfWidth;
				else if(v > 0) positionX += halfWidth;
			}
			if(isLoop) {
				eventInfo.isLock = true;
			}
			eventHandler.setPosition(positionX);
		},
		setPosition : (positionX) => {
			const width = eventInfo.width;
			const max = eventInfo.max * width * -1;
			if(positionX > 0) positionX = 0;
			else if(positionX < max) positionX = max;
			let index = Math.round(positionX / width);

			const isChanged = (eventInfo.index != Math.abs(index));
			positionX = index * width;

			const oldIndex = eventInfo.index;
			index = eventInfo.index = Math.abs(index);
			eventInfo.positionX = positionX;
			eventInfo.direction = (oldIndex < index) ? 1 : (oldIndex > index) ? -1 : 0;
			eventInfo.node.style.transform = `translateX(${positionX}px)`;

			if(!isFix) {
				eventInfo.node.style.height = eventInfo.nodeList[index].offsetHeight + "px";
			}
			if(props.onProgress) {
				const percent = (positionX * 100 / (eventInfo.maxPositionX - eventInfo.width)).toFixed(2);
				props.onProgress(percent);
			}
			setTimeout(() => {
				eventInfo.isLock = false;
				if(isChanged) {
					eventHandler.change();
				}
			}, 250);
		},
		getPosition : (direction) => {
			return (isLoop) ?
				eventInfo.positionX + (eventInfo.width / 1.75) * (direction) :
				eventInfo.width * props.index * -1;
		},
		change : () => {
			if(isLoop) {
				eventInfo.node.classList.add("focus");
				const nodeList = eventInfo.nodeList;
				const max = eventInfo.max;
				const index = eventInfo.index;

				const prevNode = (index - 1 < 0) ? nodeList[max] : nodeList[index - 1];
				const center = nodeList[index];
				const nextNode = (index + 1 > max) ? nodeList[0] : nodeList[index + 1];

				const ul = eventInfo.node.querySelector("ul");
				ul.appendChild(prevNode);
				ul.appendChild(center);
				ul.appendChild(nextNode);

				eventInfo.node.style.transform = "translateX(-100%)";
				eventInfo.positionX = eventInfo.width * -1;
				eventInfo.index = 1;
				eventInfo.nodeList = [prevNode, center, nextNode];

				setTimeout(() => {
					eventInfo.node.classList.remove("focus");
				}, 50);
			}
			if(props.onChange) {
				props.onChange(eventInfo);
			}
		},
		checkClick : (event) => {
			if(eventInfo.isDrag) {
				event.stopPropagation();
			}
		}
	};

	return (
		<Wrapper ref={self}
			 onClickCapture={eventHandler.checkClick}
			 onMouseDown={eventHandler.down}
			 onTouchStart={eventHandler.down}
			 onTouchMove={eventHandler.move}
			 onTouchEnd={eventHandler.up}
			 onTouchCancel={eventHandler.up}
		>
			<div>
				{props.children}
			</div>
		</Wrapper>
	);
});

const Wrapper = styled.div`
	&											{position:relative; width:100%; background-color:var(--lightGray); border-radius:var(--borderRadius); overflow:hidden}
	& > div										{transition:height 0.25s, transform 0.25s; cursor:grab}
	& > div:active								{cursor:grabbing}
	& > div.focus								{transition:none}
	& > div > ul								{white-space:nowrap}
	& > div > ul > li							{position:relative; display:inline-block; vertical-align:top; padding:25px; width:100%; box-sizing:border-box}
	& > div > ul > li img						{position:absolute; left:0; top:0; width:100%; height:100%; object-fit:cover}
`;

export default Slider;